import type { FormBlock, FormCondition, FormConditionsResponse, FormBlocksResponse } from './types';

export function normalizeFormBlocksResponse(
  data: FormBlocksResponse | FormBlock[] | null | undefined,
): FormBlock[] {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.blocks)) return data.blocks;
  const results = (data as { results?: FormBlock[] }).results;
  if (Array.isArray(results)) return results;
  return [];
}

export function normalizeFormConditionsResponse(
  data: FormConditionsResponse | FormCondition[] | null | undefined,
): FormCondition[] {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.conditions)) return data.conditions;
  const results = (data as { results?: FormCondition[] }).results;
  if (Array.isArray(results)) return results;
  return [];
}

export interface FormTriggerParserWire {
  raw_prompt?: string;
  raw_text?: string;
  parsed?: Record<string, unknown>;
  confirmed_at?: string | null;
  count?: number;
}

export function adaptTriggerParserFromWire(
  data: FormTriggerParserWire | null | undefined,
): { raw_text: string; parsed?: Record<string, unknown>; confirmed_at: string | null; ruleCount: number } {
  return {
    raw_text: data?.raw_prompt ?? data?.raw_text ?? '',
    ...(data?.parsed ? { parsed: data.parsed } : {}),
    confirmed_at: data?.confirmed_at ?? null,
    ruleCount: typeof data?.count === 'number' ? data.count : 0,
  };
}

export function serializeTriggerParserToWire(rawText: string): FormTriggerParserWire {
  return { raw_prompt: rawText };
}
